"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseValleyBankCsvs = void 0;
/* eslint-disable camelcase */
const common_1 = require("@finley-technologies/common");
const vbTypeguards = __importStar(require("../../typeguards"));
const utils = __importStar(require("../../utils"));
/**
 * NOTE: Valley Bank Buffers contain extra runtime fields we do not need, we will explicitly
 * pluck to prevent failure during insert in to db
 */
const parseValleyBankCsv = ({ csv, typeguard, typeName, }) => {
    const typedData = [];
    const logs = [];
    csv.forEach((row, idx) => {
        try {
            // this finleyAssert isn't strictly necessary, but makes the typing nice.
            // it is expected that ValleyBank typeguard will throw within itself, capturing the type failure error stack.
            // if the below error message is actually caught and surfaced, please refactor ValleyBank typeguard to throw.
            (0, common_1.finleyAssert)(typeguard(row), `Error parsing valleyBankBuffer [type:${typeName}. Error message: Typeguard failed.`);
            typedData.push(row);
        }
        catch (err) {
            const message = (0, common_1.getErrorMessage)(err);
            logs.push({
                level: 'error',
                file: typeName,
                column: 'N/A',
                identifier: 'N/A',
                message: `Typeguard error parsing [row:${idx}]: Message: ${message}`,
            });
        }
    });
    return { logs, data: typedData };
};
const parseVanCust = (csv, reportingDate) => {
    const { data: custs, logs } = parseValleyBankCsv({
        csv,
        typeguard: vbTypeguards.isValleyBankVanCust,
        typeName: 'ValleyBankVanCust',
    });
    return {
        logs,
        data: custs.map((cust) => ({
            bank_num: cust.bank_num,
            cif_num: cust.cif_num,
            full_name: cust.full_name,
            first_name: cust.first_name,
            last_name: cust.last_name,
            branch_code: cust.branch_code,
            officer_code: cust.officer_code,
            customer_since: cust.customer_since,
            naics_code: cust.naics_code,
            address_1: cust.address_1,
            address_2: cust.address_2,
            city: cust.city,
            state: cust.state,
            zip_code: cust.zip_code,
            ci_risk_rt: cust.ci_risk_rt,
            prospcd: cust.prospcd,
            reportingDate,
        })),
    };
};
const parseVanDepAcct = (csv, reportingDate) => {
    const { data: accounts, logs } = parseValleyBankCsv({
        csv,
        typeguard: vbTypeguards.isValleyBankVanDepAcct,
        typeName: 'ValleyBankVanDepAcct',
    });
    return {
        logs,
        data: accounts.map((account) => ({
            bank_num: account.bank_num,
            account_id: account.account_id,
            account_type_code: account.account_type_code,
            account_num: account.account_num,
            cif_num: account.cif_num,
            product_code: account.product_code,
            opened_date: account.opened_date,
            interest_rate: account.interest_rate,
            maturity_date: account.maturity_date,
            cur_balance: account.cur_balance,
            status_code: account.status_code,
            branch_num: account.branch_num,
            employee_code: account.employee_code,
            account_name: account.account_name,
            reportingDate,
        })),
    };
};
const parseVanCustAcctRel = (csv, reportingDate) => {
    const { data: rels, logs } = parseValleyBankCsv({
        csv,
        typeguard: vbTypeguards.isValleyBankVanCustAcctRel,
        typeName: 'VanCustomerAccountRelationship',
    });
    return {
        logs,
        data: rels.map((rel) => ({
            bank_num: rel.bank_num,
            app_code: rel.app_code,
            account_id: rel.account_id,
            cif_num: rel.cif_num,
            rel_code: rel.rel_code,
            reportingDate,
        })),
    };
};
const parseLoanCustRel = (csv, reportingDate) => {
    const { logs, data: rels } = parseValleyBankCsv({
        csv,
        typeguard: vbTypeguards.isValleyBankLoanCustRel,
        typeName: 'LoanCustomerRelationship',
    });
    return {
        logs,
        data: rels.map((rel) => ({
            heloan_as_of_dt: rel.heloan_as_of_dt,
            heloan_bsys_id: rel.heloan_bsys_id,
            heloan_acct_num: utils.removeLeadingZeros(rel.heloan_acct_num),
            cif_num: rel.cif_num,
            helcrel_rel_type_id: rel.helcrel_rel_type_id,
            helcrel_acct_type: rel.helcrel_acct_type,
            helcrel_portfolio_number: rel.helcrel_portfolio_number,
            reportingDate,
        })),
    };
};
const parseCuoDeposit = (csv, reportingDate) => {
    const { logs, data: deposits } = parseValleyBankCsv({
        csv,
        typeguard: vbTypeguards.isValleyBankCuoDepositSchema,
        typeName: 'CuoDeposit',
    });
    return {
        logs,
        data: deposits.map((dep) => ({
            hedeposit_bsys_id: dep.hedeposit_bsys_id,
            cif_num: dep.cif_num,
            hedeposit_acct_num: utils.removeLeadingZeros(dep.hedeposit_acct_num),
            hedeposit_acct_type: dep.hedeposit_acct_type,
            hedeposit_cur_bal: dep.hedeposit_cur_bal,
            hedeposit_avg_bal: dep.hedeposit_avg_bal,
            hedeposit_nsf_tot: dep.hedeposit_nsf_tot,
            hedeposit_last_nsf_dt: dep.hedeposit_last_nsf_dt,
            hedeposit_last_nsf_amt: dep.hedeposit_last_nsf_amt,
            hedeposit_last_activity_dt: dep.hedeposit_last_activity_dt,
            hedeposit_last_deposit_dt: dep.hedeposit_last_deposit_dt,
            hedeposit_tot_nsf_checks_paid_ytd: dep.hedeposit_tot_nsf_checks_paid_ytd,
            hedeposit_acct_open_dt: dep.hedeposit_acct_open_dt,
            hedeposit_branch_num: dep.hedeposit_branch_num,
            hedeposit_acct_status: dep.hedeposit_acct_status,
            hedeposit_acct_name: dep.hedeposit_acct_name,
            hedeposit_branch_desc: dep.hedeposit_branch_desc,
            hedeposit_frgn_currency_code: dep.hedeposit_frgn_currency_code,
            hedeposit_frgn_cur_amt: dep.hedeposit_frgn_cur_amt,
            hedeposit_frgn_cur_xfr_rate: dep.hedeposit_frgn_cur_xfr_rate,
            hedeposit_frgn_avail_bal: dep.hedeposit_frgn_avail_bal,
            hedeposit_frgn_orig_amt: dep.hedeposit_frgn_orig_amt,
            hedeposit_avail_bal: dep.hedeposit_avail_bal,
            reportingDate,
        })),
    };
};
const parseCuoCollat = (csv, reportingDate) => {
    const { logs, data: collats } = parseValleyBankCsv({
        csv,
        typeguard: vbTypeguards.isValleyBankCuoCollat,
        typeName: 'CuoCollat',
    });
    return {
        logs,
        data: collats.map((collat) => ({
            hecoll_id: collat.hecoll_id,
            hecoll_bsys_id: collat.hecoll_bsys_id,
            hecoll_desc: collat.hecoll_desc,
            hecoll_account_hold_amount: collat.hecoll_account_hold_amount,
            hecoll_file_date: collat.hecoll_file_date,
            hecoll_current_appraisal: collat.hecoll_current_appraisal,
            hecoll_type_code: collat.hecoll_type_code,
            hecoll_deposit_acct_type_id: collat.hecoll_deposit_acct_type_id,
            hecoll_deposit_account_num: collat.hecoll_deposit_account_num
                ? utils.removeLeadingZeros(collat.hecoll_deposit_account_num)
                : collat.hecoll_deposit_account_num,
            hecoll_deposit_balance: collat.hecoll_deposit_balance,
            hecoll_maturity_dt: collat.hecoll_maturity_dt,
            hecoll_frgn_currency_ind: collat.hecoll_frgn_currency_ind,
            hecoll_frgn_currency_code: collat.hecoll_frgn_currency_code,
            hecoll_frgn_cur_amt: collat.hecoll_frgn_cur_amt,
            hecoll_frgn_cur_xfr_rate: collat.hecoll_frgn_cur_xfr_rate,
            hecoll_source_system: collat.hecoll_source_system,
            hecoll_pledged_ind: collat.hecoll_pledged_ind,
            reportingDate,
        })),
    };
};
const parseCollatCustRel = (csv, reportingDate) => {
    const { logs, data: rels } = parseValleyBankCsv({
        csv,
        typeguard: vbTypeguards.isValleyBankCollatCustRel,
        typeName: 'CollatCustRel',
    });
    return {
        logs,
        data: rels.map((rel) => ({
            as_of_date: rel.as_of_date,
            bsys_code: rel.bsys_code,
            bank_number: rel.bank_number,
            he_coll_id: rel.he_coll_id,
            cif_num: rel.cif_num,
            portfolio_number: rel.portfolio_number,
            reportingDate,
        })),
    };
};
const parsePsPlusPortfolio = (csv, reportingDate) => {
    const { logs, data: ports } = parseValleyBankCsv({
        csv,
        typeguard: vbTypeguards.isValleyBankPsPlusPortfolio,
        typeName: 'PsPlusPortfolio',
    });
    return {
        logs,
        data: ports.map((port) => ({
            hecoll_id: port.hecoll_id,
            cif_num: port.cif_num,
            heccrel_portfolio_number: port.heccrel_portfolio_number,
            reportingDate,
        })),
    };
};
const parsePsPlusAccount = (csv, reportingDate) => {
    const { logs, data: accounts } = parseValleyBankCsv({
        csv,
        typeguard: vbTypeguards.isValleyBankPsPlusAccount,
        typeName: 'PsPlusAccount',
    });
    return {
        logs,
        data: accounts.map((account) => ({
            hecoll_as_of_dt: account.hecoll_as_of_dt,
            hecoll_bsys_id: account.hecoll_bsys_id,
            hecoll_bank_num: account.hecoll_bank_num,
            hecoll_id: account.hecoll_id,
            hecoll_collateral_account_number: account.hecoll_collateral_account_number,
            hecoll_desc: account.hecoll_desc,
            hecoll_desc_2: account.hecoll_desc_2,
            hecoll_current_appraisal: account.hecoll_current_appraisal,
            hecoll_type_code: account.hecoll_type_code,
            hecoll_pledged_ind: account.hecoll_pledged_ind,
            reportingDate,
        })),
    };
};
const parsePsPlusSecDetail = (csv, reportingDate) => {
    const { logs, data: details } = parseValleyBankCsv({
        csv,
        typeguard: vbTypeguards.isValleyBankPsPlusSecDetail,
        typeName: 'PsPlusSecDetail',
    });
    return {
        logs,
        data: details.map((detail) => ({
            he_secd_as_of_dt: detail.he_secd_as_of_dt,
            he_secd_bank_num: detail.he_secd_bank_num,
            hecoll_collateral_account_number: detail.hecoll_collateral_account_number,
            he_sec_security_num: detail.he_sec_security_num,
            he_secd_src_system: detail.he_secd_src_system,
            he_secd_src_system_id: detail.he_secd_src_system_id,
            he_secd_pldg_yn: detail.he_secd_pldg_yn,
            he_secd_pldg_unit: detail.he_secd_pldg_unit,
            he_secd_pldg_amt_us: detail.he_secd_pldg_amt_us,
            he_secd_pldg_amt_fx: detail.he_secd_pldg_amt_fx,
            he_secd_unpldg_unit: detail.he_secd_unpldg_unit,
            he_secd_unpldg_amt_us: detail.he_secd_unpldg_amt_us,
            he_secd_unpldg_amt_fx: detail.he_secd_unpldg_amt_fx,
            he_secd_ovrd_flg: detail.he_secd_ovrd_flg,
            he_secd_last_updt: detail.he_secd_last_updt,
            he_secd_last_updt_by: detail.he_secd_last_updt_by,
            he_secd_adv_rt: detail.he_secd_adv_rt,
            he_secd_unit_price_fx: detail.he_secd_unit_price_fx,
            he_secd_unit_price_us: detail.he_secd_unit_price_us,
            hecoll_id: detail.hecoll_id,
            he_secd_frgn_cur_fxr_rate: detail.he_secd_frgn_cur_fxr_rate,
            currency_code: detail.currency_code,
            reportingDate,
        })),
    };
};
const parsePsPlusSecMaster = ({ reportingDate, psPlusSecMasterCsv, bloombergMutualFundCsv, }) => {
    const logs = [];
    const { logs: psPlusSecMasterErrors, data: masterDetails, } = parseValleyBankCsv({
        csv: psPlusSecMasterCsv,
        typeguard: vbTypeguards.isValleyBankPsPlusSecMaster,
        typeName: 'PsPlusSecMaster',
    });
    psPlusSecMasterErrors.forEach((err) => {
        logs.push(err);
    });
    const secMasterMap = new Map();
    masterDetails.forEach((detail) => {
        if (secMasterMap.has(detail.he_sec_security_num)) {
            logs.push({
                level: 'error',
                file: 'PsPlusSecMaster',
                column: 'he_sec_security_num',
                identifier: detail.he_sec_security_num,
                message: `Duplicate psPlusSecMaster record detected during parse for [he_sec_security_num:${detail.he_sec_security_num}]`,
            });
        }
        else {
            secMasterMap.set(detail.he_sec_security_num, {
                // sec master
                he_sec_as_of_dt: detail.he_sec_as_of_dt,
                he_sec_bsys_id: detail.he_sec_bsys_id,
                he_sec_bank_num: detail.he_sec_bank_num,
                he_sec_security_num: detail.he_sec_security_num,
                he_sec_cusip: detail.he_sec_cusip,
                he_sec_country_key: detail.he_sec_country_key,
                he_sec_currency: detail.he_sec_currency,
                he_sec_sec_desc: detail.he_sec_sec_desc,
                he_sec_unit_type: detail.he_sec_unit_type,
                he_sec_ticker_symbol: detail.he_sec_ticker_symbol,
                he_sec_short_name: detail.he_sec_short_name,
                he_sec_issuer: detail.he_sec_issuer,
                he_sec_issuer_country: detail.he_sec_issuer_country,
                he_sec_asset_class: detail.he_sec_asset_class,
                he_sec_price_date: detail.he_sec_price_date,
                he_sec_unit_price_us: detail.he_sec_unit_price_us,
                he_sec_exchange: detail.he_sec_exchange,
                he_sec_rating: detail.he_sec_rating,
                he_sec_rating_src: detail.he_sec_rating_src,
                he_sec_issue_dt: detail.he_sec_issue_dt,
                he_sec_mat_dt: detail.he_sec_mat_dt,
                he_sec_redemp_dt: detail.he_sec_redemp_dt,
                he_sec_int_start: detail.he_sec_int_start,
                he_sec_coupon_per_yr: detail.he_sec_coupon_per_yr,
                he_sec_int_type: detail.he_sec_int_type,
                he_sec_asset_class_code: detail.he_sec_asset_class_code,
                he_sec_segment_code: detail.he_sec_segment_code,
                he_sec_strategy_code: detail.he_sec_strategy_code,
                he_sec_long_desc: detail.he_sec_long_desc,
                he_sec_strategy: detail.he_sec_strategy,
                he_sec_segment: detail.he_sec_segment,
                he_par_logic: detail.he_par_logic,
                // mutual fund
                isin: null,
                market_sector_des: null,
                fund_strategy: null,
                eqy_fund_ind: null,
                fund_asset_class_focus: null,
                fund_rtg_class_focus: null,
                fund_geo_focus: null,
                fund_objective_long: null,
                hb_oas_eff_durtn: null,
                yas_mod_dur: null,
                // normalized
                reportingDate,
            });
        }
    });
    const { logs: mutualFundLogs, data: mutualFundDetails } = parseValleyBankCsv({
        csv: bloombergMutualFundCsv,
        typeguard: vbTypeguards.isValleyBankBloombergMutualFund,
        typeName: 'BloombergMutualFund',
    });
    mutualFundLogs.forEach((err) => {
        logs.push(err);
    });
    mutualFundDetails.forEach((detail) => {
        const secMaster = secMasterMap.get(detail.security_number);
        // plusPlusSecMaster contained the record
        // merge the mutual fund fields
        if (secMaster) {
            secMaster.isin = detail.isin;
            secMaster.market_sector_des = detail.market_sector_des;
            secMaster.fund_strategy = detail.fund_strategy;
            secMaster.eqy_fund_ind = detail.eqy_fund_ind;
            secMaster.fund_asset_class_focus = detail.fund_asset_class_focus;
            secMaster.fund_rtg_class_focus = detail.fund_rtg_class_focus;
            secMaster.fund_geo_focus = detail.fund_geo_focus;
            secMaster.fund_objective_long = detail.fund_objective_long;
            secMaster.hb_oas_eff_durtn = detail.hb_oas_eff_durtn;
            secMaster.yas_mod_dur = detail.yas_mod_dur;
        }
        else {
            secMasterMap.set(detail.security_number, {
                // sec master
                he_sec_as_of_dt: null,
                he_sec_bsys_id: null,
                he_sec_bank_num: null,
                he_sec_cusip: null,
                he_sec_country_key: null,
                he_sec_currency: null,
                he_sec_sec_desc: null,
                he_sec_unit_type: null,
                he_sec_ticker_symbol: null,
                he_sec_short_name: null,
                he_sec_issuer: null,
                he_sec_issuer_country: null,
                he_sec_asset_class: null,
                he_sec_price_date: null,
                he_sec_unit_price_us: null,
                he_sec_exchange: null,
                he_sec_rating: null,
                he_sec_rating_src: null,
                he_sec_issue_dt: null,
                he_sec_mat_dt: null,
                he_sec_redemp_dt: null,
                he_sec_int_start: null,
                he_sec_coupon_per_yr: null,
                he_sec_int_type: null,
                he_sec_asset_class_code: null,
                he_sec_segment_code: null,
                he_sec_strategy_code: null,
                he_sec_long_desc: null,
                he_sec_strategy: null,
                he_sec_segment: null,
                he_par_logic: null,
                // mutual fund
                he_sec_security_num: detail.security_number,
                isin: detail.isin,
                market_sector_des: detail.market_sector_des,
                fund_strategy: detail.fund_strategy,
                eqy_fund_ind: detail.eqy_fund_ind,
                fund_asset_class_focus: detail.fund_asset_class_focus,
                fund_rtg_class_focus: detail.fund_rtg_class_focus,
                fund_geo_focus: detail.fund_geo_focus,
                fund_objective_long: detail.fund_objective_long,
                hb_oas_eff_durtn: detail.hb_oas_eff_durtn,
                yas_mod_dur: detail.yas_mod_dur,
                // normalized
                reportingDate,
            });
        }
    });
    return {
        logs,
        data: Array.from(secMasterMap.values()),
    };
};
const parseVanCmmt = (csv, reportingDate) => {
    const { logs, data: cmmts } = parseValleyBankCsv({
        csv,
        typeguard: vbTypeguards.isValleyBankVanCmmt,
        typeName: 'VanCmmt',
    });
    return {
        logs,
        data: cmmts.map((cmmt) => ({
            bank_num: cmmt.bank_num,
            commitment_id: cmmt.commitment_id,
            account_num: cmmt.account_num,
            commitment_num: cmmt.commitment_num,
            type: cmmt.type,
            partner_ind: cmmt.partner_ind,
            partner_bank_num: cmmt.partner_bank_num,
            lead_ind: cmmt.lead_ind,
            partner_acct_num: cmmt.partner_acct_num,
            partner_commitment_num: cmmt.partner_commitment_num,
            ultim_acct_num: cmmt.ultim_acct_num,
            ultim_commitment_num: cmmt.ultim_commitment_num,
            level: cmmt.level,
            cost_center: cmmt.cost_center,
            branch: cmmt.branch,
            revolve_ind: cmmt.revolve_ind,
            draw_ind: cmmt.draw_ind,
            term: cmmt.term,
            expire_date: cmmt.expire_date,
            renewal_date: cmmt.renewal_date,
            review_date: cmmt.review_date,
            current_amt: cmmt.current_amt,
            used_amt: cmmt.used_amt,
            unused_amt: cmmt.unused_amt,
            avail_amt: cmmt.avail_amt,
            adj_avail_amt: cmmt.adj_avail_amt,
            orig_amt: cmmt.orig_amt,
            securd_ind: cmmt.securd_ind,
            collat_code: cmmt.collat_code,
            active_status: cmmt.active_status,
            cmudf_01: cmmt.cmudf_01,
            cif_num: utils.removeLeadingZeros(cmmt.cif_num),
            account_name: cmmt.account_name,
            reportingDate,
        })),
    };
};
const parseVanLoanAcct = (csv, reportingDate) => {
    const { logs, data: accts } = parseValleyBankCsv({
        csv,
        typeguard: vbTypeguards.isValleyBankVanLoanAcct,
        typeName: 'VanLoanAcct',
    });
    return {
        logs,
        data: accts.map((acct) => ({
            loan_id: acct.loan_id,
            product_code: acct.product_code,
            loan_type_code: acct.loan_type_code,
            account_num: acct.account_num,
            status_code: acct.status_code,
            loan_status_sub_code: acct.loan_status_sub_code,
            commercial_flag: acct.commercial_flag,
            orig_date: acct.orig_date,
            orig_amt: acct.orig_amt,
            loan_date: acct.loan_date,
            current_loan_amount: acct.current_loan_amount,
            current_balance: acct.current_balance,
            current_available: acct.current_available,
            maturity_date: acct.maturity_date,
            secured_flag: acct.secured_flag,
            interest_rate: acct.interest_rate,
            account_name: acct.account_name,
            cif_num: utils.removeLeadingZeros(acct.cif_num),
            commitment_id: acct.commitment_id,
            commitment_num: acct.commitment_num,
            acct_rsk_rate: acct.acct_rsk_rate,
            cost_center: acct.cost_center,
            reportingDate,
        })),
    };
};
const parseVanList = (csv, reportingDate) => {
    const { logs, data: lists } = parseValleyBankCsv({
        csv,
        typeguard: vbTypeguards.isValleyBankVanList,
        typeName: 'VanList',
    });
    return {
        logs,
        data: lists.map((list) => ({
            bank_num: list.bank_num,
            tablename: list.tablename,
            code: list.code,
            description: list.description,
            reportingDate,
        })),
    };
};
const parseVanProduct = (csv, reportingDate) => {
    const { logs, data: products } = parseValleyBankCsv({
        csv,
        typeguard: vbTypeguards.isValleyBankVanProduct,
        typeName: 'VanProduct',
    });
    return {
        logs,
        data: products.map((product) => ({
            bank_num: product.bank_num,
            product_code: product.product_code,
            product_desc: product.product_desc,
            product_type: product.product_type,
            app_code: product.app_code,
            app_sub_code: product.app_sub_code,
            call_code: product.call_code,
            active_flag: product.active_flag,
            reportingDate,
        })),
    };
};
const parseCuoMaint = (csv, reportingDate) => {
    const { logs, data: maints } = parseValleyBankCsv({
        csv,
        typeguard: vbTypeguards.isValleyBankCuoMaint,
        typeName: 'CuoMaint',
    });
    return {
        logs,
        data: maints.map((maint) => ({
            heloan_as_of_dt: maint.heloan_as_of_dt,
            heloan_bsys_id: maint.heloan_bsys_id,
            heloan_bank_num: maint.heloan_bank_num,
            heloan_cust_num: maint.heloan_cust_num,
            heloan_acct_num: maint.heloan_acct_num,
            heloan_obgat_num: maint.heloan_obgat_num,
            heloan_cur_bal: maint.heloan_cur_bal,
            heloan_collat_analysis_bal: maint.heloan_collat_analysis_bal,
            reportingDate,
        })),
    };
};
const parseCuoLoan = (csv, reportingDate) => {
    const { logs, data: loans } = parseValleyBankCsv({
        csv,
        typeguard: vbTypeguards.isValleyBankCuoLoan,
        typeName: 'CuoLoan',
    });
    return {
        logs,
        data: loans.map((loan) => ({
            heloan_as_of_dt: loan.heloan_as_of_dt,
            heloan_bsys_id: loan.heloan_bsys_id,
            heloan_bank_num: loan.heloan_bank_num,
            cif_num: loan.cif_num,
            heloan_acct_num: loan.heloan_acct_num,
            heloan_cur_bal: loan.heloan_cur_bal,
            heloan_past_due_amt: loan.heloan_past_due_amt,
            heloan_days_past_due: loan.heloan_days_past_due,
            heloan_last_pmt_dt: loan.heloan_last_pmt_dt,
            heloan_current_credit_line_comm: loan.heloan_current_credit_line_comm,
            heloan_risk_grade: loan.heloan_risk_grade,
            heloan_mat_dt: loan.heloan_mat_dt,
            heloan_prod_type: loan.heloan_prod_type,
            heloan_int_rate: typeof loan.heloan_int_rate === 'number'
                ? loan.heloan_int_rate / 100
                : loan.heloan_int_rate,
            heloan_branch: loan.heloan_branch,
            heloan_note_dt: loan.heloan_note_dt,
            heloan_prod_type_desc: loan.heloan_prod_type_desc,
            heloan_branch_desc: loan.heloan_branch_desc,
            heloan_status: loan.heloan_status,
            heloan_acct_status: loan.heloan_acct_status,
            heloan_orig_payment_amount: loan.heloan_orig_payment_amount,
            heloan_int_guar_code: loan.heloan_int_guar_code,
            heloan_relationship: loan.heloan_relationship,
            heloan_parent_acct_num: loan.heloan_parent_acct_num,
            heloan_universal_num: loan.heloan_universal_num,
            heloan_avg_variance: loan.heloan_avg_variance,
            heloan_avail_amt: loan.heloan_avail_amt,
            heloan_next_pmt_dt: loan.heloan_next_pmt_dt,
            heloan_frgn_currency_code: loan.heloan_frgn_currency_code,
            heloan_frgn_cur_xfr_rate: loan.heloan_frgn_cur_xfr_rate,
            heloan_frgn_orig_amt: loan.heloan_frgn_orig_amt,
            heloan_frgn_cur_amt: loan.heloan_frgn_cur_amt,
            heloan_secured_ind: loan.heloan_secured_ind,
            heloan_collat_analysis_bal: loan.heloan_collat_analysis_bal,
            reportingDate,
        })),
    };
};
const parseDerivativePath = (csv, reportingDate) => {
    const { logs, data: derivativePath } = parseValleyBankCsv({
        csv,
        typeguard: vbTypeguards.isValleyBankDerivativePath,
        typeName: 'DerivativePath',
    });
    const cleanedDerivativePath = [];
    derivativePath.forEach((dp) => {
        if (typeof dp.account_num === 'string') {
            // defined by Valley Bank
            const adjustedMarkToMarket = -dp.mark_to_market;
            const initial_margin_requirement_amount = dp.usd_current_notional_amount * dp.initial_margin_requirement_rate;
            const exposure = Math.abs(initial_margin_requirement_amount + Math.min(adjustedMarkToMarket, 0));
            cleanedDerivativePath.push({
                id: dp.id,
                cif_num: dp.cif_num,
                account_num: dp.account_num,
                notional_amount: dp.notional_amount,
                source_currency: dp.source_currency,
                destination_currency: dp.destination_currency,
                fx_rate: dp.fx_rate,
                usd_current_notional_amount: dp.usd_current_notional_amount,
                initial_margin_requirement_rate: dp.initial_margin_requirement_rate,
                initial_margin_requirement_amount,
                expiration_date: dp.expiration_date,
                mark_to_market: adjustedMarkToMarket,
                product: dp.product,
                valuation_date: dp.valuation_date,
                exposure,
                reportingDate,
            });
        }
        else {
            logs.push({
                column: 'id',
                identifier: dp.id,
                file: 'DerivativePath',
                level: 'warning',
                message: `Missing account_num for DerivativePath record [id:${dp.id}]. This record will be ignored.`,
            });
        }
    });
    return {
        logs,
        data: cleanedDerivativePath,
    };
};
const parseValleyBankCsvs = ({ valleyBankCsvs: { vanCustCsv, vanCustAcctRelCsv, vanDepAcctCsv, loanCustRelCsv, cuoDepositCsv, collatCustRelCsv, cuoCollatCsv, psPlusPortfolioCsv, psPlusAccountCsv, psPlusSecDetailCsv, psPlusSecMasterCsv, vanCmmtCsv, vanLoanAcctCsv, vanListCsv, vanProductCsv, cuoLoanCsv, cuoMaintCsv, bloombergMutualFundCsv, derivativePathCsv, }, reportingDate, }) => {
    const logs = [];
    const { data: vanCust, logs: vanCustErrors } = parseVanCust(vanCustCsv, reportingDate);
    vanCustErrors.forEach((err) => logs.push(err));
    const { data: vanDepAcct, logs: vanDepAcctErrors } = parseVanDepAcct(vanDepAcctCsv, reportingDate);
    vanDepAcctErrors.forEach((err) => logs.push(err));
    const { data: vanCustAcctRel, logs: vanCustAcctRelErrors, } = parseVanCustAcctRel(vanCustAcctRelCsv, reportingDate);
    vanCustAcctRelErrors.forEach((err) => logs.push(err));
    const { data: loanCustRel, logs: loanCustRelErrors } = parseLoanCustRel(loanCustRelCsv, reportingDate);
    loanCustRelErrors.forEach((err) => logs.push(err));
    const { data: cuoDeposit, logs: cuoDepositErrors } = parseCuoDeposit(cuoDepositCsv, reportingDate);
    cuoDepositErrors.forEach((err) => logs.push(err));
    const { data: cuoCollat, logs: cuoCollatErrors } = parseCuoCollat(cuoCollatCsv, reportingDate);
    cuoCollatErrors.forEach((err) => logs.push(err));
    const { data: collatCustRel, logs: collatCustRelErrors } = parseCollatCustRel(collatCustRelCsv, reportingDate);
    collatCustRelErrors.forEach((err) => logs.push(err));
    const { data: psPlusPortfolio, logs: psPlusPortfolioErrors, } = parsePsPlusPortfolio(psPlusPortfolioCsv, reportingDate);
    psPlusPortfolioErrors.forEach((err) => logs.push(err));
    const { data: psPlusAccount, logs: psPlusAccountErrors } = parsePsPlusAccount(psPlusAccountCsv, reportingDate);
    psPlusAccountErrors.forEach((err) => logs.push(err));
    const { data: psPlusSecDetail, logs: psPlusSecDetailErrors, } = parsePsPlusSecDetail(psPlusSecDetailCsv, reportingDate);
    psPlusSecDetailErrors.forEach((err) => logs.push(err));
    const { data: psPlusSecMaster, logs: psPlusSecMasterErrors, } = parsePsPlusSecMaster({
        psPlusSecMasterCsv,
        bloombergMutualFundCsv,
        reportingDate,
    });
    psPlusSecMasterErrors.forEach((err) => logs.push(err));
    const { data: vanCmmt, logs: vanCmmtErrors } = parseVanCmmt(vanCmmtCsv, reportingDate);
    vanCmmtErrors.forEach((err) => logs.push(err));
    const { data: vanLoanAcct, logs: vanLoanAcctErrors } = parseVanLoanAcct(vanLoanAcctCsv, reportingDate);
    vanLoanAcctErrors.forEach((err) => logs.push(err));
    const { data: vanList, logs: vanListErrors } = parseVanList(vanListCsv, reportingDate);
    vanListErrors.forEach((err) => logs.push(err));
    const { data: vanProduct, logs: vanProductErrors } = parseVanProduct(vanProductCsv, reportingDate);
    vanProductErrors.forEach((err) => logs.push(err));
    const { data: cuoMaint, logs: cuoMaintErrors } = parseCuoMaint(cuoMaintCsv, reportingDate);
    cuoMaintErrors.forEach((err) => logs.push(err));
    const { data: cuoLoan, logs: cuoLoanErrors } = parseCuoLoan(cuoLoanCsv, reportingDate);
    cuoLoanErrors.forEach((err) => logs.push(err));
    const { data: derivativePath, logs: derivativePathErrors, } = parseDerivativePath(derivativePathCsv, reportingDate);
    derivativePathErrors.forEach((err) => logs.push(err));
    return {
        finleyValleyBankTapes: {
            vanCust,
            vanDepAcct,
            vanCustAcctRel,
            loanCustRel,
            cuoDeposit,
            cuoCollat,
            collatCustRel,
            psPlusPortfolio,
            psPlusAccount,
            psPlusSecDetail,
            psPlusSecMaster,
            vanCmmt,
            vanLoanAcct,
            vanList,
            vanProduct,
            cuoMaint,
            cuoLoan,
            derivativePath,
        },
        logs,
    };
};
exports.parseValleyBankCsvs = parseValleyBankCsvs;
//# sourceMappingURL=parse.js.map